import React from 'react';
import { useSelector } from 'react-redux';

export default function useLoginSelector() {
  const LoginData = useSelector((state) => state?.Login?.login_data);
  return { LoginData };
}
